// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"e528e2e1","335":"2b9817a7","395":"5fafc444","568":"ac33d81c","693":"68d2fb5d"}[chunkId] + ".chunk.js";
};